import { createSlice } from "@reduxjs/toolkit";
import {
  getGoogleSignInCheckRepo,
  postGoogleSignInDataRepo,
  postOtpVerifyRepo
} from "../../repositories/Registration/index";

const UserGoogleSignInSlice = createSlice({
  name: "userGoogleSignInReducer",
  initialState: {
    googleSigninCheckLoading: false,
    googleSigninCheckData: null,
    googleSigninCheckError: null,
    googleSignInDataLoading: false,
    googleSignInData: null,
    googleSignInDataError: null,
    otpVerifyLoading: false,
    otpVerifyCheck: null,
    otpVerifyError: null
  },
  reducers: {
    getGoogleSignInCheckLoading(state, action) {
      return {
        ...state,
        googleSignInCheckLoading: true,
      };
    },
    getGoogleSignInCheckSuccess(state, action) {
      return {
        ...state,
        googleSignInCheckLoading: false,
        googleSigninCheckData: action.payload,
        googleSignInCheckError: null,
      };
    },
    getGoogleSignInCheckFailure(state, action) {
      return {
        ...state,
        googleSignInCheckLoading: false,
        googleSignInCheckError: action.payload,
        googleSigninCheckData: null,
      };
    },
    clearGoogleSignInResponse(state, action) {
      return {
        ...state,
        googleSigninCheckData: null,
        googleSignInCheckError: null,
      };
    },
    postGoogleSignInDataLoading(state, action) {
        return {
          ...state,
          googleSignInDataLoading: true,
        };
    },
    postGoogleSignInDataSuccess(state, action) {
    return {
        ...state,
        googleSignInDataLoading: false,
        googleSigninData: action.payload,
        googleSignInDataError: null,
    };
    },
    postGoogleSignInDataFailure(state, action) {
    return {
        ...state,
        googleSignInDataLoading: false,
        googleSignInDataError: action.payload,
        googleSigninData: null,
    };
    },
    clearGoogleSignInDataResponse(state, action) {
    return {
        ...state,
        googleSigninDataData: null,
        googleSignInDataError: null,
    };
    },
    postOtpVerifyLoading(state, action) {
      return {
        ...state,
        otpVerifyLoading: true,
      };
    },
    postOtpVerifySuccess(state, action) {
    return {
        ...state,
        otpVerifyLoading: false,
        otpVerifyCheck: action.payload,
        otpVerifyError: null,
    };
    },
    postOtpVerifyFailure(state, action) {
    return {
        ...state,
        otpVerifyLoading: false,
        otpVerifyError: action.payload,
        otpVerifyCheck: null,
    };
    },
    clearOtpVerifyResponse(state, action) {
    return {
        ...state,
        otpVerifyCheck: null,
        otpVerifyError: null,
    };
    },
  },
});

export const {
  getGoogleSignInCheckLoading,
  getGoogleSignInCheckSuccess,
  getGoogleSignInCheckFailure,
  clearGoogleSignInResponse,
  postGoogleSignInDataLoading,
  postGoogleSignInDataSuccess,
  postGoogleSignInDataFailure,
  clearGoogleSignInDataResponse,
  postOtpVerifyLoading,
  postOtpVerifySuccess,
  postOtpVerifyFailure,
  clearOtpVerifyResponse
} = UserGoogleSignInSlice.actions;

export const getGoogleSignInCheck = (params) => {
  return (dispatch) => {
    dispatch(getGoogleSignInCheckLoading());
    getGoogleSignInCheckRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getGoogleSignInCheckSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error) {
          dispatch(getGoogleSignInCheckFailure(error?.response?.data));
        }
      });
  };
};

export const postGoogleSignInData = (data, token) => {
    return (dispatch) => {
      dispatch(postGoogleSignInDataLoading());
      postGoogleSignInDataRepo(data, token)
        .then((response) => {
          if (response && response.status == 200) {
            dispatch(postGoogleSignInDataSuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error) {
            dispatch(postGoogleSignInDataFailure(error?.response?.data));
          }
        });
    };
  };

  export const postOtpVerifyCheck = (data) => {
    return (dispatch) => {
      dispatch(postOtpVerifyLoading());
      postOtpVerifyRepo(data)
        .then((response) => {
          if (response && response.status == 200) {
            dispatch(postOtpVerifySuccess(response?.data?.data));
          }
        })
        .catch((error) => {
          if (error) {
            dispatch(postOtpVerifyFailure(error?.response?.data?.data));
          }
        });
    };
  };

export default UserGoogleSignInSlice.reducer;
